import { Card, formatLanguage, formatNumber } from '@platform/design-system';
import { Info } from 'lucide-react';
import type { CSSProperties } from 'react';
import { usePageContext } from '../usePageContext.ts';
import { translationCoverage, type Category } from './categories.ts';
import styles from './Categories.module.css';

export type CategoryCoverageCardProps = { categories: readonly Category[]; locales: readonly string[] };

const shareOf = (translated: number, total: number): CSSProperties =>
  ({ '--coverage-share': total === 0 ? '0' : String(translated / total) }) as CSSProperties;

export const CategoryCoverageCard = ({ categories, locales }: CategoryCoverageCardProps) => {
  const { t, locale } = usePageContext();
  return (
    <Card title={t('categoryList.coverageTitle')}>
      <div className={styles['coverage']}>
        <p className={styles['muted']}>
          {t('categoryList.coverageHelp', { language: formatLanguage(locales[0] ?? locale, locale) })}
        </p>
        <ul className={styles['coverageRows']}>
          {translationCoverage(categories, locales).map((row) => (
            <li key={row.locale}>
              <span lang={row.locale}>{formatLanguage(row.locale, row.locale)}</span>
              <span className={styles['coverageTrack']} aria-hidden="true">
                <span className={styles['coverageFill']} style={shareOf(row.translated, row.total)} />
              </span>
              <strong>
                {t('categoryList.coverageCount', {
                  translated: formatNumber(row.translated, locale),
                  total: formatNumber(row.total, locale),
                })}
              </strong>
            </li>
          ))}
        </ul>
        <p className={styles['tip']}>
          <Info size={16} aria-hidden="true" />
          <span>{t('categoryList.archiveTip')}</span>
        </p>
      </div>
    </Card>
  );
};
